import { globalVariables } from "helper/globalVariables";
import { forwardRef, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Button } from "shared/Components/button";
import Modal from "shared/Components/modal";
import { OutlineButton } from "shared/Components/outlineButton";
import { TextArea } from "shared/Components/textarea";
import { addNoteResolver } from "validators/UserValidation";

export const AddNoteModal = forwardRef((props, ref) => {
  const { title, onUpdate, btnLoading, currentNote } = props || {};

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm({
    resolver: addNoteResolver,
    defaultValues: {
      note: "",
    },
  });

  useEffect(() => {
    setValue("note", currentNote);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentNote]);

  const callBack = () => {
    reset();
    ref.current?.closeModal();
  };

  const onHandleSubmit = async (data) => {
    await onUpdate(data?.note, callBack);
  };
  watch("note");

  return (
    <Modal
      extraClass={"max-h-[400px] pt-0"}
      headerClass="sticky top-6 left-100 z-50"
      iconPosition="right-0"
      ref={ref}
    >
      <div className="bg-white w-[270px] md:w-[306px] lg:w-[406px]">
        <div className="flex justify-start flex-col pb-3 sticky top-0 bg-white pt-4">
          {!!title && (
            <span className="text-lg font-semibold text-gray-900">{title}</span>
          )}
        </div>
        <form
          className="flex flex-col items-center w-max"
          onSubmit={handleSubmit(onHandleSubmit)}
        >
          <TextArea
            register={register}
            name="note"
            placeholder={globalVariables.addNoteHere}
            errorMsg={errors.note?.message}
            value={watch("note")}
            rows={6}
            width="w-[270px] md:w-[306px] lg:w-[406px] "
          />
          <div className="mb-6" />
          <div className="flex flex-row">
            <OutlineButton
              onClick={() => {
                reset();
                ref.current?.closeModal();
              }}
              width={"w-[100px] lg:w-[190px] md:w-[140px]"}
              label={globalVariables.cancel}
            />
            <div className="ml-6" />
            <Button
              width={"w-[100px] lg:w-[190px] md:w-[140px]"}
              label={globalVariables.submit}
              disabled={btnLoading}
            />
          </div>
        </form>
      </div>
    </Modal>
  );
});
